module.exports = __webpack_public_path__ + "static/media/flower1.4bc2327c.png";